export const DEFAULT_JOB_AREA = 'Office work';

// Which work AI can already handle in each Job Area, and what stays human for now.
export const JOB_AREA_TASKS = {
  'Office work': {
    title: 'Your office work',
    aiCanDo: ['Draft emails', 'Schedule meetings', 'Summarize documents'],
    stillYou: 'Decide what matters',
  },
  'Sales & marketing': {
    title: 'Your work in sales & marketing',
    aiCanDo: ['Write campaigns', 'Research leads', 'Personalize outreach'],
    stillYou: 'Build client trust',
  },
  'Creative work': {
    title: 'Your creative work',
    aiCanDo: ['Generate images and video', 'Record voiceovers', 'Write first drafts'],
    stillYou: 'Set the creative direction',
  },
  'Tech': {
    title: 'Your work in tech',
    aiCanDo: ['Write code', 'Review code', 'Ship code'],
    stillYou: 'Decide what to build',
  },
  Finance: {
    title: 'Your work in finance',
    aiCanDo: ['Check the numbers', 'Draft reports', 'Spot mistakes'],
    stillYou: 'Judge the risk',
  },
  'Customer service': {
    title: 'Your work in customer service',
    aiCanDo: ['Answer tickets', 'Handle live chat', 'Cover the night shift'],
    stillYou: 'Calm an angry customer',
  },
  'Health or teaching': {
    title: 'Your work in health or teaching',
    aiCanDo: ['Draft notes', 'Build lesson plans', 'Summarize records'],
    stillYou: 'Care for people',
  },
  'Student or looking for work': {
    title: 'The first jobs you could get',
    aiCanDo: ['Research a topic', 'Write a first draft', 'Summarize reading'],
    stillYou: 'Stand out to employers',
  },
};
